module.exports = __webpack_public_path__ + "img/shopify.6be388e2.png";